import React, {JSX, useEffect, useState} from "react";
import {Button, IconButton} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

const usePagination = <T = any[] >(data: T|any, itemsPerPage: number = 5) => {
    const [pages, setPages] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [currentData, setCurrentData] = useState<T|[]>([]);

    const handleCurrentData = () => {
        const index = currentPage - 1;
        const newData: T|[] = data.slice(index*itemsPerPage,index*itemsPerPage + itemsPerPage)
        setCurrentData(newData);
    }

    const handlePages = () => {
        if (itemsPerPage <= 0) {
            throw new Error("usePagination: itemsPerPage can't be greater than 0.");
        }
        setPages(Math.ceil(data.length / itemsPerPage));
    }

    const getItemProps = (index: number) => ({
        variant: currentPage === index ? "filled" : "text",
        color: "gray",
        onClick: () => setCurrentPage(index),
    } as any);

    const getOptions = () => {
        let options: JSX.Element[] = [];
        for (let i = 1; i <= pages; i++) {
            options.push(
                <IconButton key={i} {...getItemProps(i)}>{i}</IconButton>
            );
        }
        return options;
    }

    const next = () => {
        setCurrentPage(currentPage + 1);
    };

    const prev = () => {
        if (currentPage === 1) return;
        setCurrentPage(currentPage - 1);
    };

    useEffect(() => {
        handleCurrentData();
    }, [data, currentPage, itemsPerPage, pages]);

    useEffect(() => {
        handlePages();
    }, [data ,itemsPerPage]);
    const getPagination = () => {
        return pages > 1 ? (
            <div className="flex justify-center items-center gap-4 pt-2 pb-3">
                <Button
                    placeholder=''
                    variant="text"
                    className="flex items-center gap-2"
                    onClick={prev}
                    disabled={currentPage === 1}
                >
                    <FontAwesomeIcon icon={faArrowLeft}/> Anterior
                </Button>
                <div className="flex items-center gap-2">
                    {getOptions()}
                </div>
                <Button
                    variant="text"
                    className="flex items-center gap-2"
                    onClick={next}
                    disabled={currentPage >= pages}
                    placeholder=''
                >
                    Siguiente
                    <FontAwesomeIcon icon={faArrowRight}/>
                </Button>
            </div>
        ) : (<></>);
    }

    return ({
        getPagination,
        currentData,
        currentPage,
        pages
    });
}

export default usePagination;